import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { StakeholderCategoryType } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'StakeholderCategorySelect',
  props: {
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var stakeholderItems = computed(function () {
      return [StakeholderCategoryType.People, StakeholderCategoryType.NaturalEnvironment, StakeholderCategoryType.PeopleAndNaturalEnvironment].map(function (item) {
        return {
          text: $i18n.t('impactGoal.impacts.defineImpacts.defineImpact.outcomeStakeholderDialog.stakeholder.' + item),
          value: item
        };
      });
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $i18n: $i18n,
      stakeholderItems: stakeholderItems
    };
  }
});